/* tslint:disable:max-line-length */
export interface ICardData {
  cardholderName: string;
  cardType: string;
  last4: string;
}

export interface ITokenizedCreditCardData {
  encryptedSecurityCode: string;
  encryptedExpiryMonth: string;
  encryptedExpiryYear: string;
  encryptedCardNumber: string;
}

export interface IBillingCardAddress {
  postalCode: string;
  countryCode: string;
}

/**
 * Fields correspond with

 * [ReverbAPI::V1::CreditCardRepresenter](https://github.com/reverbdotcom/reverb/blob/master/app/reverb_api/v1/representers/credit_card_representer.rb)
 */
export interface CreditCardResponse {
}

export function buildCardData(): ICardData {
  return {
    cardholderName: '',
    cardType: '',
    last4: '',
  };
}

export function buildTokenizedCreditCardData(): ITokenizedCreditCardData {
  return {
    encryptedSecurityCode: '',
    encryptedExpiryMonth: '',
    encryptedExpiryYear: '',
    encryptedCardNumber: '',
  };
}

export function buildBillingCardAddress(): IBillingCardAddress {
  return {
    countryCode: '',
    postalCode: '',
  };
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/card_data.ts